// id:
//   indexGroups:
//   - SOURCE_ID
//   - KEYS

export const tableYaml = () => `tables:
  - id: "||VARIABLE_KEY_id||"
    columns: {}`;
export const tableColumnYaml = () => `indexGroups: []`;
